import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';

export default function TermsCheckbox({ isChecked, setIsChecked }) {
  const [isOpen, setIsOpen] = useState(false);
  const [terms, setTerms] = useState(''); // fetched terms
  const [loading, setLoading] = useState(false);

  const modalOverlayStyles = {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '9999',
  };

  const modalContentStyles = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    maxWidth: '600px',
    width: '90%',
    maxHeight: '70%',
    overflowY: 'auto',
    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
  };

  const buttonStyles = {
    backgroundColor: 'rgb(235, 141, 22)',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginTop: '15px',
    fontSize: '1.2rem',
    padding: '8px 16px',
  };

  const termsLinkStyles = {
    color: '#007bff',
    cursor: 'pointer',
    marginLeft: '5px',
  };

  // Fetch terms from backend when modal opens
  useEffect(() => {
    const fetchTerms = async () => {
      if (isOpen) {
        setLoading(true);
        try {
          const res = await axios.get('/api/terms/terms-conditions');
          setTerms(res.data.terms || 'No terms found.');
        } catch (err) {
          console.error('Error fetching terms:', err);
          setTerms('⚠️ Failed to load Terms & Conditions.');
        } finally {
          setLoading(false);
        }
      }
    };

    fetchTerms();
  }, [isOpen]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      {/* Checkbox */}
      <div className="row pb-30">
        <div className="col-12">
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="termscheckbox"
              checked={isChecked}
              onChange={e => setIsChecked(e.target.checked)}
            />
            <label className="custom-control-label" htmlFor="termscheckbox">
              I accept the
              <span onClick={() => setIsOpen(true)} style={termsLinkStyles}>
                Terms and Conditions
              </span>
            </label>
          </div>
        </div>
      </div>

      {/* Modal Popup with Animation */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            style={modalOverlayStyles}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsOpen(false)}
          >
            <motion.div
              style={modalContentStyles}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3, ease: 'easeOut' }}
              onClick={e => e.stopPropagation()}
            >
              <h4 style={{ marginTop: 0 }}>Terms and Conditions</h4>
              {loading ? (
                <p>Loading...</p>
              ) : (
                <div
                  style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6' }}
                  dangerouslySetInnerHTML={{ __html: terms }}
                />
              )}
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button type="button" style={buttonStyles} onClick={() => setIsOpen(false)}>
                  Close
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
